import getVoicebaseMediaUrl from "./utilities/getVoicebaseMediaUrl";
import getVoicebaseAnalytics from "./utilities/getVoicebaseAnalytics";
import "@fontsource/montserrat";
import pkgJson from "../package.json";
/**
 * Decorators and standardised implementations of the player
 */
import VoicebaseReactPlayer from "./VoicebaseReactPlayer";

// import IntegratedUrlPlayer from './decorators/IntegratedUrlPlayer';

/**
 * Core player for custom implementations where a decorator isn't required
 */

VoicebaseReactPlayer.getVoicebaseMediaUrl = getVoicebaseMediaUrl;
VoicebaseReactPlayer.getVoicebaseAnalytics = getVoicebaseAnalytics;
const reactPlayerVersion = pkgJson.version;
/**
 * We export AVAILABLE schema versions as they are used as input variables.
 */
export {
  ANALYTICS_SCHEMA_VERSION_V2,
  ANALYTICS_SCHEMA_VERSION_V2_CALLBACK,
  ANALYTICS_SCHEMA_VERSION_V3,
  ANALYTICS_SCHEMA_VERSION_EVENT_STREAM,
} from "./utilities/analytics-parser";

export default VoicebaseReactPlayer;
export { getVoicebaseMediaUrl, getVoicebaseAnalytics, reactPlayerVersion };
